import styled from 'styled-components'
import arrowLeft from '../../assets/img/icon-arrow-left.svg'
import arrowRight from '../../assets/img/icon-arrow-right.svg'

export const Wrapper = styled.div`
  .pagination-container {
    margin: 32px 0 0 0;
    list-style: none;
    display: flex;
    justify-content: center;

    li {
      margin: 0 4px;
    }

    a {
      width: 40px;
      height: 40px;
      padding: 8px 12px;
      display: flex;
      justify-content: center;
      align-items: center;

      border: 1px solid #bbbbbb;
      border-radius: 4px;
      background-color: #fff;
      cursor: pointer;
      box-sizing: inherit;
      font-weight: 500;
      text-align: center;
      font-size: 14px;

      &:hover {
        background: #d22630;
        color: #fff;
      }
    }
  }

  .pagination-active a {
    background: #d22630;
    color: #fff;
  }

  .prev {
    background-image: url(${arrowLeft});
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff;

    a {
      background-color: transparent;
    }

    a:hover {
      background: transparent;
    }
  }

  .next {
    background-image: url(${arrowRight});
    background-repeat: no-repeat;
    background-position: center;
    background-color: #fff;

    a {
      background-color: transparent;
    }

    a:hover {
      background: transparent;
    }
  }

  .pagination-disabled {
    display: none;
  }
`
